import {Component, OnInit} from '@angular/core';
import {OurTeamService} from './our-team.service';
import split from 'lodash-es/split';
import {environment} from '../../../../environments/environment';
import {UserPositions} from '../../../model/user-positions';
import {AgentData} from '../../../model/agent-page-data';
import {MAX_ORDER_FIRST_BLOCK, MAX_ORDER_SECOND_BLOCK} from '../../../app.constants';

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrls: ['./our-team.component.scss'],
  providers: [OurTeamService]
})
export class OurTeamComponent implements OnInit {

  constructor(private ourTeamService: OurTeamService) {
  }

  rawUsers: AgentData[];
  cdnPath: string;
  users = new UserPositions();
  objectKeys = Object.keys;

  ngOnInit() {
    this.cdnPath = environment.cdnPath;
    this.ourTeamService.getAllUsers().subscribe(
      (response: AgentData[]) => {
        this.rawUsers = response;
        this.users.chiefs = this.rawUsers.filter(user => user.aboutOrder != null && user.aboutOrder <= MAX_ORDER_FIRST_BLOCK);
        this.users.majorAgents = this.rawUsers.filter(user => user.aboutOrder != null && user.aboutOrder > MAX_ORDER_FIRST_BLOCK && user.aboutOrder <= MAX_ORDER_SECOND_BLOCK);
        this.users.agents = this.rawUsers.filter(user => user.aboutOrder > MAX_ORDER_SECOND_BLOCK || user.aboutOrder == null);
      },
      error => {
        console.error('Error during get agents', error);
      });
  }

  prepareImage(rawImage: string) {
    return split(rawImage, '/').pop().replace('png', 'jpg');
  }

}
